import { useContext, useEffect, useState } from 'react'
import { apiGet, apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import ReactQuill from 'react-quill'
import useToastContext from 'hooks/useToastContext'
import { useTranslation } from 'react-i18next'
import AuthContext from 'context/AuthContext'
import dayjs from 'dayjs'
import ErrorMessage from 'components/ErrorMessage'
import OImage from 'components/reusable/OImage'
import noImageFound from '../../assets/images/No-image-found.jpg'
import FormData from 'form-data'
import { useForm } from 'react-hook-form'
import OInputField from 'components/reusable/OInputField'
const PrivatePolicy = () => {
  const { t } = useTranslation()
  const [content, setContent] = useState('')
  const [contentAr, setContentAr] = useState('')
  const [updateDate, setUpdateDate] = useState()
  const [photo, setPhoto] = useState('')
  const [photoError, setPhotoError] = useState('')
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm({ mode: 'onBlur', shouldFocusError: true, defaultValues: {} })
  const notification = useToastContext()
  const { logoutUser, user } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'privacy_policy') ?? {}
  const getStaticContent = async () => {
    try {
      const path = apiPath.getStaticContent
      const payload = {
        slug: 'privacy-policy'
      }
      const result = await apiGet(path, payload)
      if (result?.status === 200) {
        const response = result?.data?.results
        setUpdateDate(response?.updatedAt)
        setContent(response?.content)
        setContentAr(response?.contentAr)
        setPhoto(response?.image)
        setPhotoError(false)

        setValue('title', response?.title)
        setValue('titleAr', response?.titleAr)
        setValue('metaTitle', response?.metaTitle)
        setValue('metaTitleAr', response?.metaTitleAr)
        setValue('metaDescription', response?.metaDescription)
        setValue('metaDescriptionAr', response?.metaDescriptionAr)
        setValue('metaKeyword', response?.metaKeyword)
        setValue('metaKeywordAr', response?.metaKeywordAr)
        setValue('slug', response?.publicSlug)
        setValue('slugAr', response?.publicSlugAr)
      }
    } catch (error) {
      console.log('error in get all FAQs list==>>>>', error.message)

      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }
  const checkValid = () => {
    if (photo) {
      setPhotoError(false)
      return true
    } else {
      setPhotoError('Please select a photo')
      window.scrollTo(0, 0)
      return false
    }
  }

  const updateStaticContent = async data => {
    try {
      const isValid = checkValid()
      if (!isValid) return
      const formData = new FormData()
      formData.append('title', data?.title)
      formData.append('titleAr', data?.titleAr)
      formData.append('content', content)
      formData.append('contentAr', contentAr)
      formData.append('photo', photo)
      formData.append('metaTitle', data?.metaTitle)
      formData.append('metaTitleAr', data?.metaTitleAr)
      formData.append('metaDescription', data?.metaDescription)
      formData.append('metaDescriptionAr', data?.metaDescriptionAr)
      formData.append('metaKeyword', data?.metaKeyword)
      formData.append('metaKeywordAr', data?.metaKeywordAr)
      formData.append('publicSlug', data?.slug)
      formData.append('publicSlugAr', data?.slugAr)
      const path = `${apiPath.getStaticContent}?slug=privacy-policy`

      const result = await apiPut(path, formData)
      if (result?.status === 200) {
        notification.success(result?.data?.message)
        getStaticContent()
      }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }
  useEffect(() => {
    getStaticContent()
  }, [])
  return (
    <div>
      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <div className=' border-b-[#E3E3E3] grid 2xl:grid-cols-3 xl:grid-cols-2 lg:grid lg:grid-cols-1 gap-2 px-4 '>
              <div className='col-span-2 flex flex-wrap  items-center' />
            </div>
            <div className='pl-5 pt-4 flex'>
              <label className='mb-2 block pr-1'>
                <strong>{t('UPLOAD_IMAGE')}</strong>
              </label>
              <input
                type='file'
                name='photo'
                placeholder='Photo '
                className='form-control'
                accept='image/png,image/jpeg,image/jpg'
                onChange={event => {
                  setPhoto(event?.target?.files[0])
                }}
              />
            </div>
            {photoError && <ErrorMessage message={photoError} />}

            <div className='pl-5 pt-4 '>
              <OImage
                src={
                  typeof photo === 'object' ? URL.createObjectURL(photo) : photo
                }
                fallbackUrl={noImageFound}
              />
            </div>
            <div className='p-5 shadow-md'>
              <label className='mb-2 block'>
                <strong>{t('FAQS_CONTENT')}</strong>
              </label>
              <ReactQuill value={content} onChange={setContent} />
            </div>
            <div className='p-5 shadow-md'>
              <label className='mb-2 block'>
                <strong>{t('FAQS_CONTENT') + t('O_ARABIC')}</strong>
              </label>
              <ReactQuill value={contentAr} onChange={setContentAr} />
            </div>
            <div className='grid grid-cols-2 py-1 mt-4'>
              <div className='mb-3 mx-2'>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='title'
                    inputLabel={
                      <>
                        {t('O_TITLE')}
                        <span className='text-red-500'>*</span>
                      </>
                    }
                    type='text'
                    register={register('title', {
                      required: 'Please enter title.',
                      minLength: {
                        value: 2,
                        message: 'Minimum length must be 2.'
                      },
                      validate: value =>
                        value.trim() ? true : 'White spaces not allowed.'
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3'>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='titleAr'
                    inputLabel={
                      <>
                        {t('O_TITLE') + t('O_ARABIC')}
                        <span className='text-red-500'>*</span>
                      </>
                    }
                    type='text'
                    register={register('titleAr', {
                      required: 'Please enter title in arabic.',
                      minLength: {
                        value: 2,
                        message: 'Minimum length must be 2.'
                      },
                      validate: value => {
                        return value.trim() ? true : 'White spaces not allowed.'
                      }
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3 mx-2'>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='metaTitle'
                    inputLabel={<>{t('STATIC_TITLE')}</>}
                    type='text'
                    register={register('metaTitle', {
                      // minLength: {
                      // 	value: 2,
                      // 	message: 'Minimum length must be 2.',
                      // },
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3'>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='metaTitleAr'
                    inputLabel={<>{t('STATIC_TITLE') + t('O_ARABIC')}</>}
                    type='text'
                    register={register('metaTitleAr', {
                      // minLength: {
                      // 	value: 2,
                      // 	message: 'Minimum length must be 2.',
                      // },
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3  mx-2'>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='metaDescription'
                    inputLabel={<>{t('STATIC_DESCRIPTION')}</>}
                    type='text'
                    register={register('metaDescription', {
                      // minLength: {
                      // 	value: 2,
                      // 	message: 'Minimum length must be 2.',
                      // },
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3'>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='metaDescriptionAr'
                    inputLabel={<>{t('STATIC_DESCRIPTION') + t('O_ARABIC')}</>}
                    type='text'
                    register={register('metaDescriptionAr', {
                      // minLength: {
                      // 	value: 2,
                      // 	message: 'Minimum length must be 2.',
                      // },
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3  mx-2'>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='metaKeyword'
                    inputLabel={
                      <>
                        {t('KEYWORD')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='text'
                    register={register('metaKeyword', {
                      // required: 'Please enter keyword.',
                      // minLength: {
                      // 	value: 2,
                      // 	message: 'Minimum length must be 2.',
                      // },
                      // validate: (value) => {
                      // 	return value.trim() ? true : 'White spaces not allowed.'
                      // },
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3'>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='metaKeywordAr'
                    inputLabel={
                      <>
                        {t('KEYWORD') + t('O_ARABIC')}
                        {/* <span className='text-red-500'>*</span> */}
                      </>
                    }
                    type='text'
                    register={register('metaKeywordAr', {
                      // required: 'Please enter keyword in arabic.',
                      // minLength: {
                      // 	value: 2,
                      // 	message: 'Minimum length must be 2.',
                      // },
                      // validate: (value) => {
                      // 	return value.trim() ? true : 'White spaces not allowed.'
                      // },
                    })}
                    errors={errors}
                  />
                </label>
              </div>

              <div className='mb-3 mx-2 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='slug'
                    inputLabel={
                      <>
                        {t('O_SLUG')}
                        <span className='text-red-500'>*</span>
                      </>
                    }
                    type='text'
                    register={register('slug', {
                      required: 'Please enter slug.',
                      minLength: {
                        value: 2,
                        message: 'Minimum length must be 2.'
                      },
                      validate: value => {
                        const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/
                        if (!slugPattern.test(value)) {
                          return 'Invalid slug'
                        }
                      }
                    })}
                    errors={errors}
                  />
                </label>
              </div>
              <div className='mb-3 mx-2 '>
                <label className='block'>
                  <OInputField
                    wrapperClassName='relative z-0   w-full group'
                    name='slugAr'
                    inputLabel={
                      <>
                        {t('O_SLUG') + t('O_ARABIC')}
                        <span className='text-red-500'>*</span>
                      </>
                    }
                    type='text'
                    register={register('slugAr', {
                      required: 'Please enter slug in arabic.',
                      minLength: {
                        value: 2,
                        message: 'Minimum length must be 2.'
                      }
                    })}
                    errors={errors}
                  />
                </label>
              </div>
            </div>
          </div>
          <p style={{ marginTop: '10px', marginLeft: '10px' }}>
            {t('LAST_UPDATE')}:- {dayjs(updateDate).format('llll')}
          </p>
          <div className='2xl:ml-auto xl:ml-0 lg:pt-0 pt-2'>
            <div className='flex'>
              {(manager?.add || user?.role === 'admin') && (
                <button
                  // type='submit'
                  className='bg-[#8FC150] flex my-4 text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap'
                  onClick={handleSubmit(updateStaticContent)}
                >
                  {t('O_UPDATE')}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default PrivatePolicy
